/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default function() {
	return [ [ "hem", "hem de" ], [ "ne", "ne de" ], [ "ya", "ya da" ], [ "gerek", "gerekse de" ] ];
}
